import {List, ListItemButton, ListItemText, Typography} from "@mui/material";
import {grey, lightBlue} from "@mui/material/colors";
import moment from "moment";

export const QUICK_RANGES = [
  {label: "Last 5 minutes",  group: "Minutes",  calc: () => [moment().subtract(5,  "minutes"), moment()]},
  {label: "Last 15 minutes", group: "Minutes",  calc: () => [moment().subtract(15, "minutes"), moment()]},
  {label: "Last 30 minutes", group: "Minutes",  calc: () => [moment().subtract(30, "minutes"), moment()]},
  {label: "Last hour",       group: "Hours",    calc: () => [moment().subtract(1,  "hour"),    moment()]},
  {label: "Last 4 hours",    group: "Hours",    calc: () => [moment().subtract(4,  "hours"),   moment()]},
  {label: "Last 8 hours",    group: "Hours",    calc: () => [moment().subtract(8,  "hours"),   moment()]},
  {label: "Last 24 hours",   group: "Hours",    calc: () => [moment().subtract(24, "hours"),   moment()]},
  {label: "Today",           group: "Days",     calc: () => [moment().startOf("day"),           moment().endOf("day")]},
  {label: "Yesterday",       group: "Days",     calc: () => [moment().subtract(1, "day").startOf("day"), moment().subtract(1, "day").endOf("day")]},
  {label: "This week",       group: "Weeks",    calc: () => [moment().startOf("isoWeek"),          moment().endOf("isoWeek")]},
  {label: "Last 7 days",     group: "Weeks",    calc: () => [moment().subtract(7,  "days").startOf("day"), moment().endOf("day")]},
  {label: "Last 30 days",    group: "Months",   calc: () => [moment().subtract(30, "days").startOf("day"), moment().endOf("day")]},
  {label: "This month",      group: "Months",   calc: () => [moment().startOf("month"),         moment().endOf("month")]},
  {label: "Last month",      group: "Months",   calc: () => [moment().subtract(1, "month").startOf("month"), moment().subtract(1, "month").endOf("month")]},
  {label: "Last 3 months",   group: "Months",   calc: () => [moment().subtract(3,  "months").startOf("day"), moment().endOf("day")]},
  {label: "Last 6 months",   group: "Months",   calc: () => [moment().subtract(6,  "months").startOf("day"), moment().endOf("day")]},
  {label: "Last 12 months",  group: "Months",   calc: () => [moment().subtract(12, "months").startOf("day"), moment().endOf("day")]},
  {label: "This year",       group: "Years",    calc: () => [moment().startOf("year"),           moment().endOf("year")]},
];

/**
 * Sidebar quick-range menu.
 *
 * @param {string|null}  selected        – label of the currently active quick range
 * @param {function}     onSelect        – called with (label, startDate, endDate) where dates are JS Dates
 * @param {number}       maxHeight       – max-height in px to match the adjacent calendar
 */
const QuickRangeMenu = ({selected, onSelect, maxHeight = 320}) => {
  let lastGroup = null;

  return (
    <List
      dense
      disablePadding
      sx={{
        width: 160,
        maxHeight,
        overflowY: "auto",
        borderRight: `1px solid ${grey[200]}`,
        py: 0.5,
        "&::-webkit-scrollbar": {width: 4},
        "&::-webkit-scrollbar-thumb": {bgcolor: grey[300], borderRadius: 2},
      }}
    >
      {QUICK_RANGES.map(({label, group, calc}) => {
        const showHeader = group !== lastGroup;
        lastGroup = group;

        return [
          showHeader && (
            <Typography
              key={`header-${group}`}
              variant="caption"
              sx={{display: "block", px: 1.5, pt: showHeader && lastGroup !== group ? 1 : 0.5, pb: 0.25, color: grey[400], fontWeight: 600, letterSpacing: "0.05em", textTransform: "uppercase"}}
            >
              {group}
            </Typography>
          ),
          <ListItemButton
            key={label}
            selected={selected === label}
            onClick={() => {
              const [start, end] = calc();
              onSelect(label, start.toDate(), end.toDate());
            }}
            sx={{
              px: 1.5,
              py: 0.4,
              borderRadius: 1,
              mx: 0.5,
              minHeight: 0,
              "&.Mui-selected": {bgcolor: lightBlue[50], color: lightBlue[700]},
              "&.Mui-selected:hover": {bgcolor: lightBlue[100]},
            }}
          >
            <ListItemText
              primary={label}
              primaryTypographyProps={{variant: "body2", noWrap: true, fontSize: 12}}
            />
          </ListItemButton>,
        ];
      })}
    </List>
  );
};

export default QuickRangeMenu;
